<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.palletising.dialog.httperror' | translate }}</mat-error>
	}
	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.palletising.groupings' | translate }}</h1>

	<mat-dialog-content class="mat-dialog-content">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['name'].invalid && controls['name'].touched) {
			<mat-error>{{ 'masterdata.cutting.dialog.name.errors.empty' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.palletising.name' | translate }}</mat-label>
			<input maxlength="50" matInput formControlName="name" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.palletising.description' | translate }}</mat-label>
			<input maxlength="100" matInput formControlName="description" />
		</mat-form-field>

		@if (isCreatingGrouping) {
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['type'].invalid && controls['type'].touched) {
			<mat-error>{{ 'masterdata.palletising.dialog.errors.empty' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.palletising.dialog.type' | translate }}</mat-label>
			<mat-select formControlName="type">
				@for (type of types; track type) {
				<mat-option [value]="type">{{ type }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
		}
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.palletising.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.palletising.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
